import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import CartSidebar from '../../components/feature/CartSidebar';
import SearchModal from '../../components/feature/SearchModal';
import LoginModal from '../../components/feature/LoginModal';
import HeroSlider from './components/HeroSlider';
import CategorySection from './components/CategorySection';
import ProductsSection from './components/ProductsSection';
import FeaturesSection from './components/FeaturesSection';
import CampaignBanner from './components/CampaignBanner';
import TestimonialsSection from './components/TestimonialsSection';
import { useThemeContext } from '../../contexts/ThemeContext';

export default function Home() {
  const [searchOpen, setSearchOpen] = useState(false);
  const [loginOpen, setLoginOpen] = useState(false);
  const { theme } = useThemeContext();
  const { story, newsletter } = theme;

  return (
    <div className="min-h-screen bg-white font-sans">
      <Navbar onSearchOpen={() => setSearchOpen(true)} onLoginOpen={() => setLoginOpen(true)} />
      <main>
        <HeroSlider />
        <FeaturesSection />
        <CategorySection />
        <ProductsSection />
        <CampaignBanner />
        <TestimonialsSection />

        {/* Newsletter CTA */}
        <section className="py-20 bg-cream-light">
          <div className="max-w-7xl mx-auto px-4 lg:px-8">
            <div className="relative overflow-hidden rounded-3xl text-center py-20 px-6" style={{ background: 'linear-gradient(135deg, #2C1810 0%, #5C3D2E 50%, #2C1810 100%)' }}>
              <img src={newsletter.background_image} alt="" className="absolute inset-0 w-full h-full object-cover opacity-20" />
              <div className="relative z-10">
                <p className="text-gold font-medium text-sm tracking-widest uppercase mb-4">{newsletter.badge}</p>
                <h2 className="font-serif text-3xl lg:text-4xl xl:text-5xl font-bold text-white mb-4">{newsletter.title}</h2>
                <p className="text-cream/70 text-base lg:text-lg mb-8 max-w-lg mx-auto" dangerouslySetInnerHTML={{ __html: newsletter.description }} />
                <div className="flex items-center justify-center">
                  <button onClick={() => setLoginOpen(true)} className="px-8 py-3.5 bg-gold hover:bg-gold-dark text-white font-semibold rounded-xl transition-all duration-300 hover:scale-105 whitespace-nowrap text-sm">
                    {newsletter.cta_text}
                  </button>
                </div>
                <p className="mt-4 text-xs text-cream/40">Spam yok. İstediğin zaman çık.</p>
              </div>
            </div>
          </div>
        </section>

        {/* Origin Story */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
              <div className="relative">
                <div className="aspect-square rounded-3xl overflow-hidden">
                  <img src={story.image_url} alt="Hikayemiz" className="w-full h-full object-cover object-top" />
                </div>
                <div className="absolute -bottom-6 -right-6 bg-coffee rounded-2xl p-6 shadow-xl max-w-48">
                  <p className="font-serif text-3xl font-bold text-gold mb-1">{story.founded_year}</p>
                  <p className="text-xs text-cream/70">İlk kavrumdan bu yana</p>
                </div>
              </div>
              <div>
                <p className="text-gold font-medium text-sm tracking-widest uppercase mb-4">{story.badge}</p>
                <h2 className="font-serif text-3xl lg:text-4xl font-bold text-coffee mb-6 whitespace-pre-line">{story.title}</h2>
                <p className="text-coffee-light leading-relaxed mb-4">{story.paragraph1}</p>
                <p className="text-coffee-light leading-relaxed mb-8">{story.paragraph2}</p>
                <div className="flex flex-wrap gap-4">
                  <Link to="/hakkimizda" className="inline-flex items-center gap-2 px-6 py-3 bg-coffee text-cream font-medium rounded-xl hover:bg-coffee-medium transition-colors whitespace-nowrap text-sm">
                    Daha Fazla <i className="ri-arrow-right-line" />
                  </Link>
                  <Link to="/urunler" className="inline-flex items-center gap-2 px-6 py-3 border border-coffee-light text-coffee font-medium rounded-xl hover:bg-coffee hover:text-white hover:border-coffee transition-all whitespace-nowrap text-sm">
                    Ürünleri İncele
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <CartSidebar />
      <SearchModal isOpen={searchOpen} onClose={() => setSearchOpen(false)} />
      <LoginModal isOpen={loginOpen} onClose={() => setLoginOpen(false)} />
    </div>
  );
}
